import { Spin, SpinProps } from "antd";
import { FC } from "react";

export const XmSpinner: FC<SpinProps> = props => {
  return <Spin style={{ position: 'absolute', top: '46%', left: '49.5%', zIndex: 99 }} {...props} />;
}